import { ChangeDetectionStrategy, Component, inject, output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { PositionSelectComponent } from 'src/app/shared/components/position-select.component';
import { Posizione } from 'src/app/shared/models/posizione.model';
import { DocumentoOperazioniMassive, DocumentoOperazioniMassiveForm } from '../../../models/operazioni-massive.model';

@Component({
  selector: 'app-intestazione-ricerca',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
  <div class="advanced-search">
    <app-position-select #posizioneSelector [fullyDisabled]="false" [(ngModel)]="positionDocSearch" #copiaSelect="ngModel"></app-position-select>

    <form [formGroup]="searchForm" (ngSubmit)="search()">
      <div class="grid">

        <div class="col-12">
          <label class="small-label" for="protocollo">Protocollo</label>
          <input pInputText autocomplete="off" type="text" formControlName="protocollo" id="protocollo"
            (keyup.enter)="search()">
        </div>

        <div class="col-12">
          <app-date-filter formControlName="dataDocumento" label="Data Documento"></app-date-filter>
        </div>

        <div class="col-12 buttons flex justify-content-end">
          <button pButton type="button" icon="fas fa-search" label="Cerca" title="Cerca" (click)="search()" class="mr-2"></button>
          <button pButton type="button" icon="fas fa-eraser" label="Pulisci" title="Pulisci"
            (click)="clearForm()"></button>
        </div>
      </div>
    </form>
  </div>
  `
})
export class IntestazioneRicercaComponent {
  @ViewChild('posizioneSelector') private readonly posizioneSelector!: PositionSelectComponent;

  onSearch = output<DocumentoOperazioniMassive>();
  onReset = output<boolean>();

  private readonly fb = inject(FormBuilder);

  public positionDocSearch: Posizione[] = [];
  public searchForm: FormGroup<DocumentoOperazioniMassiveForm>;

  public mezzoDistruzioneValues: string[] = ['Fuoco', 'Macchina Tritacarte', 'Macchina Polpatrice'];

  constructor() {
    this.searchForm = this.fb.group<DocumentoOperazioniMassiveForm>({
      protocollo: new FormControl(''),
      dataDocumento: new FormControl(null),
    });
  }

  public isFascicoloSelected(): boolean {
    return (this.positionDocSearch.length !== 0 && this.positionDocSearch[0] !== null && typeof this.positionDocSearch[0] === 'object');
  }

  public search(): void {
    const value: DocumentoOperazioniMassive = { posizione: this.positionDocSearch, protocollo: this.searchForm.value.protocollo ?? '', dataDocumento: this.searchForm.value.dataDocumento ?? [] };
    this.onSearch.emit(value);
  }

  public clearForm(): void {
    this.searchForm.reset();
    this.positionDocSearch = [];
    this.posizioneSelector?.clearForm();

    this.onReset.emit(true);
  }

}
